/**
 * Hook para verificar si existe una wallet por address o email.
 */
import { useQuery } from "react-query";
import { Queries } from "ui/query/queries";
import { config } from "common/config";
import { walletApi } from "../api/walletApi";

export function useAddressExists(addressOrEmail: string) {
    return useQuery(
        [Queries.ADDRESS_EXISTS, addressOrEmail],
        () =>
            walletApi
                .existsByAddressOrEmail(addressOrEmail, config.organization.address)
                .then((d) => d.exists),
        {
            enabled: Boolean(addressOrEmail),
            cacheTime: 0,
        }
    );
}
